export const getProductColor = (pathname) => {
  if (pathname.includes("osenvelt"))
    return "#2B2E8F";
  if (pathname.includes("stoboclo"))
    return "#007178";        
  if (pathname.includes("zymfentra"))
    return "#652E6C";
  if (pathname.includes("avtozma"))
    return "#0092B4";   
  return "#000000";
};

export const getBorderColor = (pathname) => {
 if (pathname.includes("osenvelt"))
      return "rselection-wrap role-wrap osenvelt-card";
 if (pathname.includes("stoboclo"))
      return "rselection-wrap role-wrap stoboclo-card";        
 if (pathname.includes("steqeyma"))
      return "rselection-wrap role-wrap steqeyma-card";         
 if (pathname.includes("avtozma"))
      return "rselection-wrap role-wrap avtozma-card";          
    if (pathname.includes("zymfentra"))
      return "rselection-wrap role-wrap zymfentra-card";
    return "rselection-wrap role-wrap";
  };  


export const getProductButtonColor = (pathname) => {
  if (pathname.includes("osenvelt"))
    return "#2B2E8F";
  if (pathname.includes("stoboclo"))
    return "#007178";        
  if (pathname.includes("steqeyma"))
    return "#006838";
  if (pathname.includes("avtozma"))
    return "#ff5d36";  
  if (pathname.includes("vegzelma"))
    return "#004580";
  return "#662d91";
};  

export const getPrimaryButtonClass = (pathname) => {
 if (pathname.includes("osenvelt"))
      return "osenvelt-backbtn";
 if (pathname.includes("stoboclo"))
      return "stoboclo-backbtn";        
 if (pathname.includes("avtozma"))
      return "avtozma-backbtn";       
    return "backbtn";
  };  

  export const getProductName = (pathname) => {
      if (pathname.includes("steqeyma"))
        return "STEQEYMA";
   if (pathname.includes("osenvelt"))
        return "OSENVELT";
   if (pathname.includes("stoboclo"))
        return "STOBOCLO";   
   if (pathname.includes("avtozma"))
        return "AVTOZMA";                
      if (pathname.includes("zymfentra"))
        return "ZYMFENTRA";
      if (pathname.includes("yuflyma"))
        return "YUFLYMA";
      if (pathname.includes("vegzelma"))
        return "VEGZELMA";    
      return "ADALIMUMAB";
    };

  export const getMedicationGuideLink = (pathname) => {
      if (pathname.includes("avtozma"))
        return "https://www.avtozma.com/wp-content/uploads/2025/08/AVTOZMA-pi.pdf";
    if (pathname.includes("steqeyma"))
        return "https://www.steqeyma.com/wp-content/uploads/2025/02/STEQEYMA-Med-Guide.pdf";
   if (pathname.includes("osenvelt"))
        return "https://www.osenvelt.com/wp-content/uploads/2025/06/OSENVELT_PrescribingInformation.pdf";
   if (pathname.includes("stoboclo"))
        return "https://www.stoboclo.com/wp-content/uploads/2025/05/stoboclo-prescribing-information.pdf";        
      if (pathname.includes("zymfentra"))
        return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2023/761358s000lbl.pdf";
      if (pathname.includes("adalimumab"))
        return "https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=c44365e9-d470-4e35-978d-8565a9e3471e&type=display";
      if (pathname.includes("vegzelma"))
        return "https://www.vegzelma.com/final-labeling-text_202302.pdf";    
      return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2023/761219s000lbl.pdf";
    };    